import styled from 'shared/utils/styled';

type StatusViewAccessories = Partial<{
  error: boolean;
  success: boolean;
}>;

const SpaceRenovationRequestStatus = styled('span', {
  shouldForwardProp: (prop) => prop !== 'error' && prop !== 'success',
})<StatusViewAccessories>(({ theme, error = false, success = false }) => ({
  color: success
    ? theme.palette.success.main
    : error
    ? theme.palette.error.main
    : 'inherit',
}));

export default SpaceRenovationRequestStatus;
